import { render, staticRenderFns } from "./DeliveryNoteManagement.vue?vue&type=template&id=bed632b6"
import script from "./DeliveryNoteManagement.vue?vue&type=script&lang=ts"
export * from "./DeliveryNoteManagement.vue?vue&type=script&lang=ts"
import style0 from "./DeliveryNoteManagement.vue?vue&type=style&index=0&id=bed632b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports